export default "__VITE_ASSET__CZyI5eA9__"